import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that checks if the current URL path corresponds to a firm page
 * Firm URLs follow the pattern: /firms/:firmSlugParam/:tableSlugParam
 * 
 * @returns {boolean} True if the current path is a firm path, false otherwise
 */
export const useIsFirmPath = (): boolean => {
  const location = useLocation();

  const isFirmPath = useMemo(() => {
    const { pathname } = location;    
    return !['/companies/', '/funds/'].includes(pathname);
  }, [location]);

  return isFirmPath;
};
